// @ts-nocheck
/* Shared product-page CTA scroll (FAQ / Comparison / V2–V4 sections).
   Works with Product Info Custom, V2, V3, and Product Info V4. */
(function () {
  'use strict';

  const $ = (sel, ctx = document) => (ctx || document).querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from((ctx || document).querySelectorAll(sel));

  function headerOffset() {
    const raw = getComputedStyle(document.documentElement).getPropertyValue('--sticky-header-offset').trim();
    const n = parseInt(raw, 10);
    return Number.isNaN(n) ? 80 : n;
  }

  function docTop(el) {
    if (!el) return 0;
    let top = 0;
    let node = el;
    while (node) {
      top += node.offsetTop || 0;
      node = node.offsetParent;
    }
    return top;
  }

  function resolveTarget(id) {
    if (!id) return null;
    return (
      document.getElementById(id) ||
      document.querySelector(`[data-pi-scroll-anchor="${id.replace(/"/g, '\\"')}"]`)
    );
  }

  function scrollToPurchase(anchorId, smooth) {
    const id = (anchorId || 'product-purchase').replace(/^#+/, '').trim();
    const piSection = document.querySelector('.pi-section');
    const piv3Section = document.querySelector('[data-piv3]') || document.querySelector('.piv3-section');
    const piv4Section = document.querySelector('[data-product-info-v4]') || document.querySelector('.product-info-v4');
    const startEl =
      (piv4Section && $('[data-piv4-purchase-start]', piv4Section)) ||
      (piv4Section && $('[data-pi-purchase-start]', piv4Section)) ||
      (piv3Section && $('[data-piv3-purchase-start]', piv3Section)) ||
      (piv3Section && $('[data-pi-purchase-start]', piv3Section)) ||
      (piSection && $('[data-pi-purchase-start]', piSection)) ||
      document.querySelector('[data-piv4-purchase-start]') ||
      document.querySelector('[data-piv3-purchase-start]') ||
      document.querySelector('[data-pi-purchase-start]') ||
      resolveTarget(id) ||
      (piv4Section && $('.piv4-title', piv4Section)) ||
      (piv3Section && $('.piv3-title', piv3Section)) ||
      (piSection && $('.pi-title', piSection)) ||
      document.querySelector('.piv2-title') ||
      piv4Section ||
      piv3Section;

    if (!startEl) return;
    const scrollTop = Math.max(0, docTop(startEl) - headerOffset() - 8);
    window.scrollTo({ top: scrollTop, behavior: smooth ? 'smooth' : 'auto' });
  }

  function onCtaClick(e) {
    const btn = e.currentTarget;
    if (btn.tagName === 'A' || btn.tagName === 'BUTTON') e.preventDefault();
    const raw = btn.getAttribute('data-pi-scroll-target') || '';
    const id = raw.replace(/^#+/, '').trim();
    if (!id) return;
    const smooth = btn.hasAttribute('data-pi-scroll-smooth');
    if (btn.hasAttribute('data-pi-scroll-purchase')) {
      scrollToPurchase(id, smooth);
      return;
    }
    const target = resolveTarget(id);
    if (!target) return;
    target.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' });
  }

  function bindAll() {
    $$('[data-pi-scroll-target]').forEach((btn) => {
      if (btn._piScrollBound) return;
      btn._piScrollBound = true;
      btn.addEventListener('click', onCtaClick);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll);
  } else {
    bindAll();
  }

  document.addEventListener('shopify:section:load', bindAll);
})();
